import React from "react";
import LoadableComponent from "./lazy";
import { IProps } from "./interfaces";

export default (props: IProps) => <LoadableComponent {...props} />;
